import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import EnquiryForm from "./EnquiryForm";
import useScrollReveal from "../hooks/useScrollReveal";

const CTAPage = ({ eyebrow, title, subtitle, image, highlights, formProps }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useScrollReveal([title]);

  return (
    <>
      <Navbar />
      <section
        className="pt-[118px] pb-14 md:pb-20 px-5 md:px-8"
        style={{
          background:
            "radial-gradient(1000px 500px at 88% 0%, hsl(var(--primary)/0.10) 0%, hsl(var(--primary)/0) 55%), hsl(var(--background))",
        }}
      >
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="fade-up">
            <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">{eyebrow}</span>
            <h1 className="font-heading font-extrabold text-[#1B2A4A] text-[38px] md:text-[50px] leading-[1.05] tracking-tight mt-3">
              {title}
            </h1>
            <span className="block w-14 h-[3px] rounded-full bg-[#159A90] mt-4 mb-5" />
            <p className="text-[#57616e] text-[16px] md:text-[17px] leading-relaxed max-w-xl">{subtitle}</p>
            <ul className="grid sm:grid-cols-2 gap-3 mt-8">
              {highlights.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#159A90]/12 shrink-0 mt-0.5">
                    <Check size={13} className="text-[#159A90]" />
                  </span>
                  <span className="text-[14.5px] text-[#3a4757] leading-snug">{h}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="fade-up">
            <div className="rounded-[26px] overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.14)]">
              <img src={image} alt={title} className="w-full h-[280px] md:h-[420px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-28 px-5 md:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center fade-up mb-8">
            <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[26px] md:text-[34px]">{formProps.heading}</h2>
            <p className="text-[#57616e] mt-3">{formProps.subheading}</p>
          </div>
          <div className="fade-up">
            <EnquiryForm
              category={formProps.category}
              extraLabel={formProps.extraLabel}
              extraOptions={formProps.extraOptions}
              submitLabel={formProps.submitLabel}
            />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CTAPage;
